import { useQuery } from '@hooks/reactQuery';

import { getDashboardRequestStatusesSummary } from '@api/dashboardPO';

import { getRequestsStatusesOrder } from '@utils/tableUtils';

import { TSortedDataParams } from '@interfaces/common/response';
import { ISort } from '@interfaces/common/store';
import { IDashboardRequestStatusSummary } from '@interfaces/platform/platformDashboard';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_REQUEST_STATUSES_SUMMARY } from '@constants/queryKeys';

const getSortedData = ({
	data,
	sortDirection,
	sortFieldName,
}: TSortedDataParams<IDashboardRequestStatusSummary>) => {
	if (!data) return [];

	if (!sortFieldName) return data.filter(item => !!item);

	return [...data].sort((a, b) => {
		const [first, second] = sortDirection ? [a, b] : [b, a];

		switch (sortFieldName) {
			case 'status':
				return getRequestsStatusesOrder(first.status.name) - getRequestsStatusesOrder(second.status.name);
			case 'organizationCount':
				return first.organizationCount - second.organizationCount;
			case 'requestCount':
				return first.requestCount - second.requestCount;
			default:
				return 0;
		}
	}).filter(item => !!item);
};

const useQueryDashboardRequestStatusesSummary = ({
	sortDirection,
	sortFieldName,
}: ISort) => {
	const {
		data,
		isLoading: isLoadingDashboardRequestStatusesSummary,
		isFetching: isFetchingDashboardRequestStatusesSummary,
	} = useQuery({
		queryKey: [DASHBOARD_REQUEST_STATUSES_SUMMARY],
		queryFn: () => getDashboardRequestStatusesSummary(),
		...refetchOptions,
	});

	const dashboardRequestStatusesSummary = getSortedData({
		data,
		sortDirection,
		sortFieldName,
	});

	return {
		dashboardRequestStatusesSummary,
		isLoadingDashboardRequestStatusesSummary: isLoadingDashboardRequestStatusesSummary
			|| isFetchingDashboardRequestStatusesSummary,
	};
};

export default useQueryDashboardRequestStatusesSummary;
